import React, { useState, useEffect } from "react";
import axios from "axios";
import SmartLink from "../../utils/SmartLink";
import links from "../../assets/menu.json";

/**
 * Pone en mayúscula la inicial de la etiqueta del menú.
 *
 * Algunos enlaces están guardados en minúscula en Drupal ("historias") y
 * desentonaban junto a "Datos" o "GeoMedellín". Se corrige al pintar y no en la
 * base de datos porque es compartida con otros entornos. Solo se toca la primera
 * letra: con `text-transform: capitalize` saldría "Medellín En Cifras".
 */
const capitalizeFirst = (label) => {
  if (typeof label !== 'string' || label.length === 0) return label;
  return label.charAt(0).toUpperCase() + label.slice(1);
};

const Menu = () => {
  const [menuItems, setMenuItems] = useState([]);
  const [loading, setLoading] = useState(true);

  // Links de respaldo desde el JSON estático
  const fallbackMenu = links.main;

  useEffect(() => {
    const fetchMenuItems = async () => {
      try {
        // Usar el endpoint custom que es accesible para usuarios anónimos
        const response = await axios.get('/api/menu/main');

        if (response.data && response.data.data && response.data.data.length > 0) {
          const items = response.data.data.map(item => ({
            id: item.id,
            label: item.title,
            url: item.url,
            weight: item.weight
          }));
          setMenuItems(items);
        } else {
          // Si no hay items en Drupal, usar fallback
          setMenuItems(fallbackMenu);
        }
      } catch (error) {
        console.error('Error fetching menu items:', error);
        // En caso de error, usar el menú estático como fallback
        setMenuItems(fallbackMenu);
      } finally {
        setLoading(false);
      }
    };

    fetchMenuItems();
  }, []);

  return (
    <ul className="menu-inner">
      {loading ? (
        <li className="menu-item">
          <span className="menu-link">Cargando...</span>
        </li>
      ) : (
        menuItems.map((item, index) => (
          <li className="menu-item" key={item.id || index}>
            <SmartLink to={item.url} className="menu-link">
              {capitalizeFirst(item.label)}
            </SmartLink>
          </li>
        ))
      )}
    </ul>
  );
};

export default Menu;
